import { render } from "./ResultsScreen.vue?vue&type=template&id=e7578a58"
import script from "./ResultsScreen.vue?vue&type=script&lang=js"
export * from "./ResultsScreen.vue?vue&type=script&lang=js"

import "./ResultsScreen.vue?vue&type=style&index=0&id=e7578a58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__